import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-1/3">
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-background-50 mb-4 whitespace-nowrap">
              韩漫漫画网
            </h2>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md">
              韩漫漫画网汇聚海量韩国漫画资源，提供高清流畅的在线阅读体验。我们致力于成为中文世界最优质的韩漫阅读平台，让每一位漫画爱好者都能在这里找到喜爱的作品。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-1/3 flex flex-col gap-8">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-3 whitespace-nowrap">联系方式</h4>
              <p className="text-foreground-400 text-sm">hello@ihua3.com</p>
              <p className="text-foreground-400 text-sm mt-1">商务合作：hello@ihua3.com</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-3 whitespace-nowrap">办公地址</h4>
              <p className="text-foreground-400 text-sm">北京市朝阳区望京SOHO</p>
              <p className="text-foreground-400 text-sm mt-1">T1栋B座1208室</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-3 whitespace-nowrap">客服热线</h4>
              <p className="text-foreground-400 text-sm">400-888-6688</p>
              <p className="text-foreground-400 text-sm mt-1">工作日 9:00 - 18:00</p>
            </div>
          </div>

          <div className="lg:w-1/3">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20aesthetic%20art%2C%20vertical%20composition%2C%20beautiful%20character%20illustration%2C%20warm%20lighting%2C%20atmospheric%2C%20dreamy%20style%2C%20soft%20colors%2C%20webtoon%20art%20style%2C%20clean%20and%20elegant&width=400&height=560&seq=footer-brand-01&orientation=portrait"
              alt="韩漫漫画网品牌形象"
              title="韩漫漫画网 - 韩国漫画阅读平台"
              className="w-full max-w-[200px] lg:max-w-[240px] h-auto rounded-lg object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/30">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs whitespace-nowrap">
            &copy; 2026 韩漫漫画网 版权所有 | 京ICP备2026XXXXXX号
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}